import React from "react";
import { motion } from "framer-motion";

const CombinedCards = () => {
  const cards = [
    {
      title: "End-to-End Solutions",
      text: "From concept validation and detailed design to shop drawing preparation and site support.",
      color: "linear-gradient(135deg, #0c1f4a, #1e3c72)",
      circleColor: "#0c1f4a",
    },
    {
      title: "Collaborative Approach",
      text: "Early engagement ensures seamless integration with project stakeholders.",
      color: "linear-gradient(135deg, #f36f21, #f9a03f)",
      circleColor: "#f36f21",
    },
    {
      title: "Cost & Time Efficiency",
      text: "Optimized workflows and proactive problem-solving minimize delays and budget overruns.",
      color: "linear-gradient(135deg, #0c1f4a, #1e3c72)",
      circleColor: "#0c1f4a",
    },
    {
      title: "Commitment to Safety",
      text: "Designs grounded in rigorous analysis and adherence to the latest safety standards.",
      color: "linear-gradient(135deg, #f36f21, #f9a03f)",
      circleColor: "#f36f21",
    },
  ];

  return (
    <div style={styles.container}>
      {cards.map((card, index) => (
        <motion.div
          key={index}
          style={styles.cardContainer}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: index * 0.2 }}
          viewport={{ once: true }}
        >
          {/* Left side timeline effect */}
          <div style={styles.timeline}>
            <motion.div
              style={{ ...styles.circle, backgroundColor: card.circleColor }}
              whileHover={{ rotate: 360 }}
              transition={{ duration: 0.6 }}
            />
            {index < cards.length - 1 && (
              <motion.div
                style={styles.line}
                initial={{ height: 0 }}
                whileInView={{ height: 60 }}
                transition={{ duration: 0.6, delay: 0.3 }}
              />
            )}
          </div>

          {/* Right side card */}
          <motion.div
            style={{ ...styles.card, background: card.color }}
            whileHover={{ scale: 1.05, rotate: -1 }}
            transition={{ duration: 0.4 }}
          >
            <h3 style={styles.cardTitle}>{card.title}</h3>
            <p style={styles.cardText}>{card.text}</p>
          </motion.div>
        </motion.div>
      ))}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "50px",
    maxWidth: "900px",
    margin: "0 auto",
    padding: "50px 20px",
  },
  cardContainer: {
    display: "flex",
    alignItems: "flex-start",
    gap: "25px",
  },
  timeline: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "60px",
  },
  circle: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
  },
  line: {
    width: "4px",
    background: "rgba(0,0,0,0.2)",
    flexGrow: 1,
    marginTop: "10px",
  },
  card: {
    flex: 1,
    padding: "25px",
    borderRadius: "15px",
    color: "#fff",
    boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
    transition: "all 0.3s ease",
  },
  cardTitle: {
    fontSize: "20px",
    marginBottom: "8px",
    fontWeight: "600",
  },
  cardText: {
    fontSize: "14px",
    lineHeight: "1.6",
  },
};

export default CombinedCards;
